import request from '../utils/request'
import { RETRIEVE_PROVIDER, UPDATE_PROVIDER, LIST_PROVIDER, ACCEPTED_PROVIDER,
	STAND_BY_PROVIDER, REFUSAL_PROVIDER, MEETING_PROVIDER, APPROVED_PROVIDER, CREATE_NEW_LEAD_PROVIDER,
    VALID_DOCUMENT } from './ProviderConstants'
import { addNotifSuccess, addNotifError } from '../notification/NotificationActions'

export const createNewLeadProvider = (values) => {
    return {
        type: CREATE_NEW_LEAD_PROVIDER,
        payload: request.post('provider/new/', values)
    }
};

export const retrieveProvider = (id) => {
    return {
        type: RETRIEVE_PROVIDER,
        payload: request.get('provider/'+id+'/')
    }
};

export const listProvider = (network, date = undefined) => {
    return {
        type: LIST_PROVIDER,
        payload: request.get('provider/?type=approuve&network='+network+(date ? "&date="+date : ''))
    }
};

export const updateProvider = (id, values) => {
    return {
        type: UPDATE_PROVIDER,
        payload: request.patch('provider/'+id+'/', values)
    }
};

export const acceptedProvider = (id, network) => {
    return {
        type: ACCEPTED_PROVIDER,
        payload: request.patch('provider/'+id+'/accepted/', network)
    }
};

export const standByProvider = (id, network) => {
    return {
        type: STAND_BY_PROVIDER,
        payload: request.patch('provider/'+id+'/stand-by/', network)
    }
};

export const refusalProvider = (id, refusal_reason) => {
    return {
        type: REFUSAL_PROVIDER,
        payload: request.patch('provider/'+id+'/rejected/', refusal_reason)
    }
};

export const meetingProvider = (id, rdv) => {
    return {
        type: MEETING_PROVIDER,
        payload: request.patch('provider/'+id+'/meeting/', rdv)
    }
};

export const approvedProvider = (id, rdv) => {
    return {
        type: APPROVED_PROVIDER,
        payload: request.patch('provider/'+id+'/approved/')
    }
};

export const validDocument = (id, valid) => {
    return {
        type: VALID_DOCUMENT,
        payload: request.patch('provider/'+id+'/document/', valid)
    }
};


export const uploadDocument = (id, file, name) => {

	return function(dispatch){
		var data = new FormData();
		data.append('file', file);
		var filename = null;

		if(file.type === "application/pdf")
			filename = name+".pdf";
		if(file.type === "image/jpeg")
			filename = name+".jpg";
		if(file.type === "image/png")
			filename = name+".png";

        console.log(filename);

		if(filename){
            // request.defaults.headers['Content-Disposition'] = 'attachment; filename='+filename
			request.defaults.headers['Content-Disposition'] = filename;

			request.post('provider/'+id+'/upload/', data)
			.then(function (res) {
	          	dispatch(retrieveProvider(id))
	        })
	        .catch(function (err) {
	          	dispatch(addNotifError("Erreur", "Veuillez recommencer."))
	        });
		}

	}

}

export const deleteDocument = (id, name) => {
	return function(dispatch){
		var obj = {};
		obj[name] = null;
		return dispatch(updateProvider(id, obj))
	}
}



// WEBPACK FOOTER //
// ./src/provider/ProviderActions.js